import { signal, effect } from '@preact/signals';
import type { GetOffersResponse, GetMixedOffersSearchResponse } from 'service/offer/resource';

export const DEFAULT_OFFERS_VALUE: GetOffersResponse = { pagination: { total: 0, limit: 0, offset: 0 }, results: [] };

export const offers = signal<GetMixedOffersSearchResponse>(DEFAULT_OFFERS_VALUE);

if (globalThis?.window) {
	effect(() => {
		// eslint-disable-next-line @typescript-eslint/no-unused-expressions
		offers.value; // Access the signal to attach this effect to it

		if (typeof globalThis.window.sssp?.setPageViewId === 'function') {
			globalThis.window.sssp.setPageViewId(null, true);
		}
	});
}
